export enum SEARCH_QUERY_FIELDS {
  QUERY = 'query',
  TAG = 'tag',
  CATEGORY = 'category',
}
